import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'

import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '「佐渡島（さど）の金山」をフカボリ！―世界遺産登録への道― | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="みんなで学ぶ連載記事" />
      <SectionTitle sectionTitle="「佐渡島（さど）の金山」をフカボリ！―世界遺産登録への道―⑨" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2024夏号 No.167 目次",
                path: "/no167"
              },
              {
                name: "みんなで学ぶ連載記事"
              }
            ]}
          />
        <p>この連載では、「佐渡島（さど）の金山」の見どころや歴史などを毎回お伝えします。県民みんなで知識の鉱脈をフカボリしましょう！<br />県では世界遺産登録に向け、今後も取り組んでいきます。</p>
        
        <div>
          <img
            src={`${basePath}/no167/img/4-1.png`}
            alt="佐渡を世界遺産に"
            css={style.img(200, "15px 0 0 0")}
          />
        </div>
        
        <p>「相川まつり」は、相川地区の総鎮守である善知鳥（うとう）神社の祭りです。島内最大級、江戸時代前期から約400年の歴史を持っています。<br />祭りでは、神輿が奉行所前も含めた鉱山町の街路を練り歩き、翁のお面を付けた豆蒔き（踊り手）が太鼓とともに町内の一軒一軒をまわり、各戸の繁栄を願って桝を持って舞い踊ります。<br />また、太鼓を叩くのは相川上町地区の大工町に住む金穿（かなほり）大工たちがつとめてきたもので、太鼓を叩く所作は、鎚とタガネで鉱石を掘る様子を真似たものだとも言い伝えられています。<br />鉱山とそこで暮らす人々と関連深いこの祭りは、今も相川で脈々と受け継がれています。</p>
        
        <div>
          <img
            src={`${basePath}/no167/img/4-2.png`}
            alt="太鼓に合わせて舞い踊る豆蒔きの翁"
            css={style.img(300, "15px 0 15px 0")}
          />
        </div>
        
        <p>詳しくは
          <a
            href="https://www.sado-goldmine.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        <br />
        <p>【問い合わせ】<br />文化課&emsp;世界遺産登録推進室&emsp;電話：<a href="tel:025-280-5726">025-280-5726</a></p>
        
        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
